import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
const navItems = [{
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Cómo trabajamos',
  href: '#proceso'
}, {
  label: 'Clientes',
  href: '#clientes'
}, {
  label: 'Equipo',
  href: '#equipo'
}, {
  label: 'Preguntas',
  href: '#faq'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200" data-id="element-131">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-132">
        <div className="flex items-center justify-between" data-id="element-133">
          <a href="#" className="flex items-center" data-id="element-134">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rbqnTT3WAHBizaFCFvc1JL/logo.png" alt="Enlaces Consultora" className="h-12" data-id="element-135" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-136">
            {navItems.map((item, index) => <a key={index} href={item.href} className="text-slate-700 hover:text-emerald-600 font-medium transition-colors" data-id="element-137">
                {item.label}
              </a>)}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 text-slate-700 hover:text-emerald-600 transition-colors" data-id="element-138">
            {isOpen ? <XIcon className="w-6 h-6" data-id="element-139" /> : <MenuIcon className="w-6 h-6" data-id="element-140" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden pt-4 pb-2" data-id="element-141">
            <div className="flex flex-col space-y-3" data-id="element-142">
              {navItems.map((item, index) => <a key={index} href={item.href} onClick={() => setIsOpen(false)} className="text-slate-700 hover:text-emerald-600 font-medium py-2 transition-colors" data-id="element-143">
                  {item.label}
                </a>)}
            </div>
          </motion.div>}
      </div>
    </nav>;
}